import { getAxiosInstance } from '../client';
/** Mutation functions for webpush/push notifications */
export const webpushMutations = {
    /**
     * POST /webpush/should-restore-subscription — true if the automatic heal may
     * (re)subscribe this user: they still have a stored subscription AND still want
     * at least one push type (so we never re-enable push they turned off).
     */
    shouldRestoreSubscription: () => getAxiosInstance()
        .post('/webpush/should-restore-subscription')
        .then((r) => r.data),
    /** POST /webpush/has-specific-subscription */
    hasSpecificSubscription: (subscriptionData) => getAxiosInstance()
        .post('/webpush/has-specific-subscription', subscriptionData)
        .then((r) => r.data),
    /** POST /webpush/save-subscription */
    saveSubscription: (dto) => getAxiosInstance()
        .post('/webpush/save-subscription', dto)
        .then((r) => r.data),
    /** POST /webpush/delete-subscription */
    deleteSubscription: (subscriptionData) => getAxiosInstance()
        .post('/webpush/delete-subscription', subscriptionData)
        .then((r) => r.data),
};
//# sourceMappingURL=webpush.mutations.js.map